import { aioRoutes } from './aio_data';
import { commonRoutes } from './common_data';
import { manageRoutes } from './manage_data';
import { purchaserRoutes } from './purchaser_data';
import { supplyRoutes } from './supply_data';

export const RouterName = {
  ...commonRoutes,
  ...aioRoutes,
  ...manageRoutes,
  ...supplyRoutes,
  ...purchaserRoutes,
};
